import { tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_MandatoryPropsSimulationDemoEvent = {
    eventId: tsValidateUniqueId,
    label: tsValidateString(),
};
const Validator_GeneratedProps = {};
export const DBDef_SimulationDemoEvent = {
    modifiablePropsValidator: Validator_MandatoryPropsSimulationDemoEvent,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'simulation--demo-event',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'simulation--demo-events',
    },
    backend: {
        name: 'simulation--demo-events',
    },
    entityName: 'SimulationDemoEvents',
    dependencies: {
        eventId: {
            dbKey: 'encounter-events',
            fieldType: 'string',
        },
    },
};
//# sourceMappingURL=db-def.js.map